import { render, staticRenderFns } from "./news-add.vue?vue&type=template&id=73bf2fbd&scoped=true&"
import script from "./news-add.vue?vue&type=script&lang=js&"
export * from "./news-add.vue?vue&type=script&lang=js&"
import style0 from "./news-add.vue?vue&type=style&index=0&id=73bf2fbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bf2fbd",
  null
  
)

export default component.exports